import React, { useEffect, useState, useRef } from 'react'
import {
	Flexgrid,
	FlexgridItem,
	IconInformationalLight,
	HelpButton,
	RadioButton,
	TextInput,
	Form,
} from '@wf-wfria/pioneer-core'
import { FormattedMessage } from 'react-intl'

export function CustomerContractInvoiceNumberRICOH({
	focusedElement,
	formatMessage,
	customerNumberRicoh,
	contractNumberRicoh,
	invoiceNumber,
	contractOrInvoice,
	contractNumberRicohInputClasses,
	invoiceNumberInputClasses,
	onChange,
	onFocusFactory,
	onSelectContractOrInvoice,
	onTextInputValidator,
}) {
	const [key, setKey] = useState(Date.now())
	const formRef = useRef()
	const valueMissing = formatMessage({ id: 'required-field.empty.error.label' })
	const contractOrInvoiceInputDisabled =
		!contractOrInvoice && !!customerNumberRicoh

	useEffect(() => {
		if (
			focusedElement !== 'email' &&
			focusedElement !== 'invoiceNumber' &&
			focusedElement !== 'customerNumberRicoh' &&
			focusedElement !== 'contractNumberRicoh'
		) {
			if (formRef.current?.validateField) {
				formRef.current.resetField('invoiceNumber')
				formRef.current.resetField('customerNumberRicoh')
				formRef.current.resetField('contractNumberRicoh')
			}

			const newKey = Date.now()
			setKey(newKey)
		}
	}, [focusedElement, setKey])

	function getContractOrInvoice(contractOrInvoice) {
		if (contractOrInvoice === 'contract') {
			return 'contractNumberRicoh'
		}
		return 'invoiceNumber'
	}

	function getContractOrInvoiceInputClasses(contractOrInvoice) {
		if (contractOrInvoice === 'contract') {
			return contractNumberRicohInputClasses
		}
		return invoiceNumberInputClasses
	}

	function invokeOnSelectContractOrInvoice({ value }) {
		onSelectContractOrInvoice(value)
	}

	return (
		<Form action="#" ref={formRef}>
			<Flexgrid direction="column" rowGap={2} style={{ marginTop: '12px' }}>
				<FlexgridItem>
					<Flexgrid
						span={{
							xxs: 12,
							sm: 6,
						}}
					>
						<RadioButton
							label={formatMessage({
								id: 'wca-form.new-user-registration.customer-and-contract-number-ricoh.label',
							})}
							value={'contract'}
							name="customerAndContractNumber"
							onValueChange={invokeOnSelectContractOrInvoice}
							checked={contractOrInvoice === 'contract'}
						/>
						<span className="HelpBody">
							<HelpButton
								helpBody={
									<>
										{formatMessage({
											id: 'wca-form.new-user-registration.ricoh.customercontract',
										})}
									</>
								}
								kind="chromeless"
								aria-label={formatMessage({
									id: 'wca-form.new-user-registration.ricoh.customercontract',
								})}
								centerIcon={<IconInformationalLight size="small" />}
							/>
						</span>
						<RadioButton
							label={formatMessage({
								id: 'wca-form.new-user-registration.customer-and-invoice-number.label',
							})}
							value={'invoice'}
							name="CustomerAndInvoiceNumber"
							onValueChange={invokeOnSelectContractOrInvoice}
							checked={contractOrInvoice === 'invoice'}
						/>
					</Flexgrid>
				</FlexgridItem>
				<FlexgridItem>
					<Flexgrid columnGap={2}>
						<FlexgridItem
							span={{
								xxs: 12,
								sm: 6,
							}}
						>
							<TextInput
								key={key}
								aria-label={formatMessage({
									id: 'wca-form.new-user-registration.customer-number.label',
								})}
								label={formatMessage({
									id: 'wca-form.new-user-registration.customer-number.label',
								})}
								aria-required={true}
								required={true}
								labelHidden={true}
								disabled={contractOrInvoiceInputDisabled}
								id={'customerNumberRicoh'}
								name="customerNumberRicoh"
								type="text"
								size="25"
								value={customerNumberRicoh.value}
								onValueChange={onChange}
								onFocus={onFocusFactory('WcaRegister')}
								customValidators={[
									(value) => onTextInputValidator('customerNumberRicoh', value),
								]}
								nativeValidationMessages={{
									valueMissing,
								}}
							/>
						</FlexgridItem>
						{contractOrInvoice !== 'invoice' && (
							<FlexgridItem span={{ xxs: 12, sm: 6 }}>
								<TextInput
									key={key}
									aria-label={formatMessage({
										id: 'wca-form.new-user-registration.contract-or-invoice-number.label',
									})}
									label={formatMessage({
										id: 'wca-form.new-user-registration.contract-or-invoice-number.label',
									})}
									aria-required={true}
									required={true}
									labelHidden={true}
									disabled={contractOrInvoiceInputDisabled}
									id={'contractNumberRicoh'}
									name="contractNumberRicoh"
									type="text"
									size="25"
									value={contractNumberRicoh.value}
									onValueChange={onChange}
									onFocus={onFocusFactory('WcaRegister')}
									className={getContractOrInvoiceInputClasses('contract')}
									customValidators={[
										(value) =>
											onTextInputValidator(
												getContractOrInvoice('contract'),
												value,
											),
									]}
									nativeValidationMessages={{
										valueMissing,
									}}
								/>
							</FlexgridItem>
						)}
						{contractOrInvoice === 'invoice' && (
							<FlexgridItem span={{ xxs: 12, sm: 6 }}>
								<TextInput
									aria-label={formatMessage({
										id: 'wca-form.new-user-registration.contract-or-invoice-number.label',
									})}
									label={formatMessage({
										id: 'wca-form.new-user-registration.contract-or-invoice-number.label',
									})}
									aria-required={true}
									required={true}
									disabled={contractOrInvoiceInputDisabled}
									id={'invoiceNumber'}
									name="invoiceNumber"
									type="text"
									size="25"
									value={invoiceNumber.value}
									onValueChange={onChange}
									onFocus={onFocusFactory('WcaRegister')}
									customValidators={[
										(value) =>
											onTextInputValidator(
												getContractOrInvoice('invoice'),
												value,
											),
									]}
									nativeValidationMessages={{
										valueMissing,
									}}
								/>
							</FlexgridItem>
						)}
					</Flexgrid>
				</FlexgridItem>
			</Flexgrid>
		</Form>
	)
}
